module.exports = __webpack_public_path__ + "img/map.6128ff1a.svg";